
define('jst!layouts/_header_count_v2',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="<%= iconClass %>"></div>\n\n<% if (hoverIcon) { %>\n  <div class="<%= hoverIcon %>"></div>\n<% } %>\n\n<div class="counter"></div>\n\n');
 });

